import React, { Component } from "react";
import "../styles/callDetailsModal.scss";
import ChevronRightIcon from "../img/chevron_right.svg";
import InfoBlock from "./infoBlock";
import { Dialog } from "@material-ui/core";
import format from "date-fns/format";
import HomeIcon from "../img/home_work.svg";
import BipononIcon from "../img/biponon.svg";
import ClipBoardIcon from "../img/pending_actions.svg";
import PeopleIcon from "../img/account_circle.svg";
import BkashIcon from "../img/bkash_logo.svg";
import InfoImage from "./infoImage";

export default class CallDetailsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  toggleOpen = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  render() {
    if (!this.props.details) return null;
    const {
      outlet_image,
      qr_image_link,
      outlet__name,
      bmcc__code,
      bmcc__name,
      spot_code__code,
      spot_code__name,
      outlet_type,
      outlet__address,
      call_outcome,
      zone_aware_upload_time,
      field_force__whitelisting_number,
      field_force__name,
      field_force__reporting_manager__reporting_agency__name,
      outlet__wallet_no,
      field_force_id,
      outlet_id,
      startDate,
      endDate,
    } = this.props.details;
    return (
      <div className="new-call-detail-modal-container">
        <button onClick={this.toggleOpen}>
          Details <img src={ChevronRightIcon} />
        </button>
        <Dialog
          open={this.state.isOpen}
          onClose={this.toggleOpen}
          maxWidth="md"
        >
          <div className="new-call-details-dialog-container">
            <div className="call-outlet-name">{outlet__name}</div>
            <div className="call-outlet-address">{outlet__address}</div>
            <div className="call-outlet-upload-time">
              Uploaded at{" "}
              {format(
                new Date(zone_aware_upload_time),
                "h:mm a, cccc dd MMMM, yyyy"
              )}
              {/* <img src={ClockIcon} /> */}
            </div>
            <div className="images">
              <InfoImage imgSrc={outlet_image} title="Outlet" />
              <InfoImage imgSrc={qr_image_link} title="QR" />
            </div>
            <div className="info-container-call-details-modal">
              <InfoBlock
                icon={PeopleIcon}
                title="Field Force"
                info={field_force__whitelisting_number}
                subInfo={field_force__name}
                secondarySubInfo={
                  field_force__reporting_manager__reporting_agency__name
                }
                topVariant
                goToPath={`/field-force?id=${field_force_id}&start=${format(
                  new Date(startDate),
                  "yyyy-MM-dd"
                )}&end=${format(new Date(endDate), "yyyy-MM-dd")}`}
              />
              <InfoBlock
                icon={BkashIcon}
                title="bKash Wallet Number"
                info={outlet__wallet_no}
                topVariant
                goToPath={`/outlets/${outlet_id}`}
              />
              <InfoBlock
                icon={HomeIcon}
                title="BMCC"
                info={bmcc__code}
                subInfo={bmcc__name}
              />
              <InfoBlock
                icon={HomeIcon}
                title="Spot"
                info={spot_code__code}
                subInfo={spot_code__name}
              />
              <InfoBlock
                icon={BipononIcon}
                title="Wallet type"
                info={outlet_type}
              />

              <InfoBlock
                icon={ClipBoardIcon}
                title="Call outcome"
                info={call_outcome}
                isCallOutcome
              />
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}
